<template>
  <div
    :class="{
      'basket-item': true,
      'basket-item-reserving': !item.reserved && !ignoreReserved,
      row: true,
      'recently-updated-animate': recentlyUpdated,
      'd-none': hide,
      faded: faded,
    }"
    :id="id"
    @animationend="$emit('animationend')"
  >
    <div class="col-3 align-self-center" v-if="!noImage">
      <PuSkeleton height="100px" :loading="loading">
        <div
          class="basket-item-reserving-overlay"
          v-if="
            !item.reserved &&
            !ignoreReserved &&
            item.stockstatus !== 'Apply' &&
            item.stockstatus !== 'Pre-Order'
          "
        >
          <img
            src="/app/themes/jeroboams-2020/dist/images/loader-200.svg"
            width="60px"
          />
        </div>
        <a :href="item.url">
          <img v-if="!loading" :src="item.img" class="img-fluid" />
        </a>
      </PuSkeleton>
    </div>
    <div class="col align-self-center">
      <div class="row">
        <div class="col-12">
          <div class="float-right delete-item" @click="removeItem()">
            <svg
              class="bi"
              width="1rem"
              height="1rem"
              fill="currentColor"
              v-if="!(loading || loadingQuantityUpdate)"
            >
              <use
                xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#x-circle"
              />
            </svg>
          </div>
          <PuSkeleton :count="2" :loading="loading">
            <div class="mb-1" v-if="item.stockstatus !== 'Stock'">
              <div
                class="stockstatus-label"
                v-if="item.stockstatus === 'Pre-Order'"
              >
                <svg class="bi" width="1rem" height="1rem" fill="currentColor">
                  <use
                    xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#exclamation-circle"
                  />
                </svg>

                Pre-Order
              </div>
              <div
                class="stockstatus-label"
                v-if="item.stockstatus === 'Apply'"
              >
                <svg class="bi" width="1rem" height="1rem" fill="currentColor">
                  <use
                    xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#exclamation-circle"
                  />
                </svg>

                Apply for this product
              </div>
            </div>
            <h6 class="basket-item-title">
              <a :href="item.url">{{ item.title }}</a>
            </h6>
          </PuSkeleton>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-5 type-title-small align-self-center">
          <PuSkeleton height="34px" :loading="loading || loadingQuantityUpdate">
            <quantity
              v-if="!frozen"
              :value="item.quantity"
              @input="updateQuantity"
            ></quantity>
          </PuSkeleton>

          <!-- <span class="type-body-small">
            <PuSkeleton
              height="34px"
              :loading="loading || loadingQuantityUpdate"
            >
              {{ item.format | inflect(item.quantity) }}
            </PuSkeleton>
          </span> -->
        </div>
        <div class="col-7 align-self-center text-right">
          <PuSkeleton height="34px" :loading="loading || loadingQuantityUpdate">
            <span
              class="basket-item-price"
              v-if="item.stockstatus === 'Stock'"
              >{{ (item.unit_cost * item.quantity) | currency }}</span
            >
            <span v-else class="basket-item-price">
              <span v-if="item.unit_future_cost <= 0 && item.unit_range_from === 0 && item.unit_range_to === 0">
                Price TBA
              </span>
              <span v-else-if="item.unit_future_cost <= 0">
                {{ (item.unit_range_from * item.quantity) | currency }} -
                {{ (item.unit_range_to * item.quantity) | currency }}
              </span>
              <span v-else>
                {{ (item.unit_future_cost * item.quantity) | currency }}
              </span>
            </span>
          </PuSkeleton>
        </div>
      </div>
      <div class="row align-items-center mt-1">
        <div class="col basket-labels" v-if="!loading && !error">
          <div
            class="duty-label duty-label-dp"
            v-if="item.duty === 'DP' && !noDutyLabel"
          >
            <svg class="bi" width="1rem" height="1rem" fill="currentColor">
              <use
                xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#shop"
              />
            </svg>
            Duty Paid
          </div>
          <div
            class="duty-label duty-label-ib"
            v-if="item.duty === 'IB' && !noDutyLabel"
          >
            <svg class="bi" width="1rem" height="1rem" fill="currentColor">
              <use
                xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#door-closed"
              />
            </svg>
            In Bond
          </div>
          <div
            class="reserving-label"
            :class="{ 'ml-0': noDutyLabel }"
            v-if="
              (!item.reserved || loadingQuantityUpdate) &&
              !ignoreReserved &&
              item.stockstatus !== 'Apply' &&
              item.stockstatus !== 'Pre-Order'
            "
          >
            <svg class="bi" width="1rem" height="1rem" fill="currentColor">
              <use
                xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrow-repeat"
              />
            </svg>
            Reserving stock
          </div>
          <div
            class="unavailable-label"
            :class="{ 'ml-0': noDutyLabel }"
            v-else-if="!ignoreReserved && item.reserved === 'error'"
          >
            <svg class="bi" width="1rem" height="1rem" fill="currentColor">
              <use
                xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#bag-x"
              />
            </svg>
            Stock unavailable
          </div>
          <div
            class="reserved-label"
            :class="{ 'ml-0': noDutyLabel }"
            v-else-if="
              !ignoreReserved &&
              item.stockstatus !== 'Apply' &&
              item.stockstatus !== 'Pre-Order'
            "
          >
            <svg class="bi" width="1rem" height="1rem" fill="currentColor">
              <use
                xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#bag-check"
              />
            </svg>
            Stock reserved
          </div>
          <div
            class="reserved-label"
            :class="{ 'ml-0': noDutyLabel }"
            v-else-if="
              item.stockstatus !== 'Apply' && item.stockstatus !== 'Pre-Order'
            "
          >
            <svg class="bi" width="1rem" height="1rem" fill="currentColor">
              <use
                xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#bag-x"
              />
            </svg>
            <b-link @click="showLogin">Log in to reserve stock </b-link>
          </div>
        </div>
        <div class="col" v-if="error">
          <div class="error-label">
            <svg class="bi" width="1rem" height="1rem" fill="currentColor">
              <use
                xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#exclamation-circle"
              />
            </svg>
            {{ error }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global gtag fbq */
import Vue from "vue";
import { CardPlugin, FormInputPlugin } from "bootstrap-vue";
import Quantity from "@/components/Quantity";

Vue.use(CardPlugin);
Vue.use(FormInputPlugin);

export default {
  data() {
    return {
      animate: true,
      loadingGlobal: false,
      loadingQuantityUpdate: false,
    };
  },
  components: {
    Quantity,
  },
  computed: {
    loading() {
      return this.loadingGlobal || this.frozen;
    },
  },
  watch: {},
  methods: {
    removeItem() {
      this.$bvModal
        .msgBoxConfirm(
          "Are you sure you want to remove " + this.item.title + "?",
          {
            okVariant: "danger",
            centered: true,
          }
        )
        .then((val) => {
          if (val) {
            this.updateQuantity(0);
          }
        });
    },
    updateQuantity(newQty) {
      if (newQty == 0) {
        this.loadingGlobal = true;
      } else {
        this.loadingQuantityUpdate = true;
      }

      if (newQty < this.item.quantity) {
        gtag("event", "remove_from_cart", {
          currency: "GBP",
          items: [
            {
              id: this.item.sku,
              name: this.item.title,
              price: this.item.unit_cost,
              quantity: this.item.quantity - newQty,
              variant: this.item.duty,
            },
          ],
          value: this.item.unit_cost * (this.item.quantity - newQty),
        });
      } else {
        gtag("event", "add_to_cart", {
          currency: "GBP",
          items: [
            {
              id: this.item.sku,
              name: this.item.title,
              price: this.item.unit_cost,
              quantity: newQty - this.item.quantity,
              variant: this.item.duty,
            },
          ],
          value: this.item.unit_cost * (newQty - this.item.quantity),
        });

        fbq("track", "AddToCart", {
          content_name: this.item.title,
          content_ids: [this.item.sku],
          content_type: "product",
          value: this.item.unit_cost * (newQty - this.item.quantity),
          currency: "GBP",
        });
      }

      this.$store
        .dispatch("basket/update_quantity", {
          key: this.itemKey,
          quantity: newQty,
        })
        .then(() => {
          this.loadingQuantityUpdate = false;
          this.loadingGlobal = false;
        })
        .catch(() => {
          this.loadingQuantityUpdate = false;
          this.loadingGlobal = false;
        });
    },
  },
  props: {
    noDutyLabel: {
      type: Boolean,
      default: false,
    },
    noImage: {
      type: Boolean,
      default: false,
    },
    faded: {
      type: Boolean,
      default: false,
    },
    itemKey: String,
    item: Object,
    id: String,
    frozen: Boolean,
    recentlyUpdated: Boolean,
    hide: Boolean,
    ignoreReserved: Boolean,
    error: {
      type: [String, Boolean],
      default: false,
    },
  },
};
</script>